/* Drill-down panels for the mobile menu.
   One panel is visible at a time; opening slides the child in, back returns to
   the root. Focus moves with the panel so keyboard and screen-reader users
   follow the same path, and Escape steps back rather than trapping. */
(() => {
  if (window.cloudMobileNavBound) return;
  window.cloudMobileNavBound = true;

  const show = (nav, id) => {
    nav.querySelectorAll('[data-mnav-panel]').forEach((panel) => {
      const active = panel.dataset.mnavPanel === id;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    nav.dataset.mnavCurrent = id;
    const target = nav.querySelector(`[data-mnav-panel="${id}"]`);
    target?.scrollTo?.({ top: 0 });
    target?.querySelector('button, a')?.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-mnav-open]');
    if (open) {
      const nav = open.closest('[data-cloud-mnav]');
      if (nav) {
        event.preventDefault();
        show(nav, open.dataset.mnavOpen);
      }
      return;
    }

    const back = event.target.closest('[data-mnav-back]');
    if (back) {
      const nav = back.closest('[data-cloud-mnav]');
      if (nav) {
        event.preventDefault();
        show(nav, 'root');
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const nav = event.target.closest?.('[data-cloud-mnav]');
    if (nav && nav.dataset.mnavCurrent && nav.dataset.mnavCurrent !== 'root') {
      event.stopPropagation();
      show(nav, 'root');
    }
  });

  /* Closing the menu should not leave a child panel showing next time. */
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!details.matches?.('.cloud-header__mobile-menu') || details.open) return;
    details.querySelectorAll('[data-cloud-mnav]').forEach((nav) => show(nav, 'root'));
  }, true);
})();
